import { classes as htmlClasses } from 'html-classes';
import { observer } from 'mobx-react-lite';

import { company } from '~/company/Company';
import { createCategoryUrl } from '~/components/CategoryBlocks/utils';

import { Card } from '../shared/Card';
import { GridView, tileClassNames } from '../shared/GridView';
import { BlockCommonProps } from '../shared/interfaces';
import { ViewAllButton } from '../shared/ViewAllButton';

import styles from './ListOfCategories1.module.scss';

const ListOfCategories1 = ({ classes, category }: BlockCommonProps) => {
  if (!category.subcategory.length || !category.subcategory[0]?.id) {
    return null;
  }

  const { titleClassName } = classes || {};

  return (
    <div className={styles.wrapper}>
      {category.subcategory.map((subcategory) => (
        <div className={styles.root} key={subcategory.id}>
          <div className={styles.head}>
            <h3 className={htmlClasses([styles.title, titleClassName])}>
              {subcategory.name}
            </h3>
            <ViewAllButton link={createCategoryUrl({ id: subcategory.id })} />
          </div>

          <GridView className={styles.content}>
            {subcategory.subcategory.map((thirdLvlCategory) => {
              const tileClassName =
                typeof thirdLvlCategory.tileSize === 'number' &&
                company.tileSizeEnabled
                  ? tileClassNames[thirdLvlCategory.tileSize]
                  : tileClassNames[1];

              return (
                <Card
                  key={thirdLvlCategory.id}
                  category={thirdLvlCategory}
                  classes={{
                    tileClassName,
                    titleClassName: styles.cardTitle,
                  }}
                />
              );
            })}
          </GridView>
        </div>
      ))}
    </div>
  );
};

export default observer(ListOfCategories1);
